/* eslint-disable @typescript-eslint/no-unused-vars */
export const kendoMultiSelectStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({

  '.k-multiselect': {
    border: `1px solid ${palette.neutralSecondary}`,
    padding: 0,
    minHeight: '32px',
    height: 'auto',

    '& .k-multiselect-wrap': {
      height: 'auto',
      zoom: 1,

      '& .k-reset': {
        margin: 0,
        padding: 0,

        '& .k-button': {
          margin: 2,
          padding: '0 8px',
          fontSize: 14,
          float: 'left',
          listStyle: 'none',
          height: '27px',
          lineHeight: '27px',
          backgroundColor: palette.neutralLight,

          '& span:first-child': {
            maxWidth: '180px',
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            display: 'inline-block',
            verticalAlign: 'middle',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            marginTop: '-4px',
          },

          '& .k-edit': {
            margin: '1px 0 0 8px',
            fontFamily: iconFontFamily,
            fontSize: 14,
            verticalAlign: 'middle',
          },

          '& .k-edit:before': {
            content: '"\\E711"',
          },
        },
      },

      '& .k-input': {
        height: '26px',
        border: 0,
        margin: '3px 20px 0 5px',
        paddingLeft: 0,
        maxWidth: 380,
        float: 'left',
        outline: 'none',
      },
    },

    '& .k-multiselect-wrap:after': {
      clear: 'both',
      content: '""',
      display: 'block',
      height: 0,
      width: 0,
    },
  },

});
